import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_ROLE = "listRole";
export const GET_DETAIL_ROLE = "detailRole";
export const SAVE_ROLE = "saveRole";
export const UPDATE_DATA_ROLE = "updateDataRole";
export const DELETE_ROLE = "deleteRole";
export const UPLOAD_AVATAR_ROLE = "uploadRole";
export const GET_DATA_SEARCH_ROLE = "getDataSearchRole";
export const SET_DATA_SEARCH_ROLE = "setDataSearchRole";

export const SET_LIST_ROLE = "setListRole";
export const SET_DETAIL_ROLE = "setDetailRole";


const state = {
    roles: [],
    role: {},
    dataSearchRole: [],
};

const getters = {
    roles(state) {
        return state.roles;
    },
    role(state) {
        return state.role;
    },
    dataSearchRole(state) {
        return state.dataSearchRole;
    },
};

const actions = {
    [GET_LIST_ROLE](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_ROLE).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_ROLE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_ROLE](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_ROLE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_ROLE, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_ROLE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_ROLE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_DATA_ROLE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_ROLE}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_ROLE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_ROLE}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },

    [GET_DATA_SEARCH_ROLE](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_SEARCH_ROLE, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_ROLE, data.data.data);
                }
                resolve(data);
            });
        });
    },
};

const mutations = {
    [SET_LIST_ROLE](state, data) {
        state.roles = data.data;
    },
    [SET_DETAIL_ROLE](state, data) {
        state.role = data.data;
    },
    [SET_DATA_SEARCH_ROLE](state, data) {
        state.dataSearchRole = data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};